import {createLazyFileRoute} from '@tanstack/react-router'

import FoodCart from '@/views/FoodGrubhub/FoodGrubhubCart/FoodGrubhubCart'

export const Route = createLazyFileRoute('/_food-grubhub/food/cart')({
  component: FoodCart,
})
